import { AxiosResponse } from 'axios';
import { CertificateRegistry } from '../../../Model/Dto/CertificateRegistry/CertificateRegistry';
import { SearchResult } from '../../../Model/Dto/SearchResult';
import { axiosCoreInstance } from '../../AxiosCoreInterceptor';

import * as ApiUrls from './ApiUrl.CertificateRegistry';

export const CertificateRegistryService = {
    Search: (input: CertificateRegistry.CertificateRegistrySearchRequest): Promise<AxiosResponse<SearchResult<CertificateRegistry.CertificateRegistrySearchResult>>> =>
        axiosCoreInstance.post(ApiUrls.Search, input),
    CreateCertificateEntry: (data: CertificateRegistry.Dto): Promise<AxiosResponse<CertificateRegistry.Dto>> =>
        axiosCoreInstance.post(ApiUrls.CertificateRegistry, data),
    UpdateCertificateEntry: (data: CertificateRegistry.Dto): Promise<AxiosResponse<CertificateRegistry.Dto>> =>
        axiosCoreInstance.put(ApiUrls.CertificateRegistry, data),
    DeleteCertificateEntry: (id: number): Promise<AxiosResponse<CertificateRegistry.Dto>> =>
        axiosCoreInstance.delete(`${ApiUrls.CertificateRegistry}${id}`),
    GetCertificateEntryById: (id: number): Promise<AxiosResponse<CertificateRegistry.Dto>> =>
        axiosCoreInstance.get(`${ApiUrls.CertificateRegistry}${id}`),
    GetScorecardTypesForFieldsMapping: (): Promise<AxiosResponse<CertificateRegistry.FieldMappingDto[]>> =>
        axiosCoreInstance.get(ApiUrls.ScorecardTypesForFieldsMapping),
    ValidateCertificateNumberVersion: (data: CertificateRegistry.ValidateDto): Promise<AxiosResponse<boolean>> =>
        axiosCoreInstance.post(ApiUrls.ValidateCertificateNumberVersion, data),
    GetLatestPublishedCertificate: (scorecardId: string): Promise<AxiosResponse<SearchResult<CertificateRegistry.CertificateRegistrySearchResult>>> =>
        axiosCoreInstance.get(`${ApiUrls.GetLatestPublishedCertificate}${scorecardId}`),
};
